export default __webpack_public_path__ + "static/media/a015-2.522320cf.svg";